"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

// Wraps a component where you automatically want to dispatch a [close] action during one of the following events:
//  1. User clicks "outside" of the component.
//  2. User presses the Esc[ape] key.
var ClosableWrapper = /** @class */
function (_super) {
  (0, _tslib.__extends)(ClosableWrapper, _super);
  function ClosableWrapper(props) {
    var _this = _super.call(this, props) || this;
    _this.onKeyDown = function (event) {
      var ESC_KEY_CODE = 27; // tslint:disable-next-line:deprecation

      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === ESC_KEY_CODE) {
        _this.props.onCloseRequested();
      }
    };
    _this.onClick = function (event) {
      if (_this.ref && !_this.ref.contains(event.target)) {
        _this.props.onCloseRequested();
      }
    };
    return _this;
  }
  ClosableWrapper.prototype.componentDidMount = function () {
    document.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKeyDown);
  };
  ClosableWrapper.prototype.componentWillUnmount = function () {
    document.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKeyDown);
  };
  ClosableWrapper.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      tag = _a.tag;
    var element = tag ? tag : 'span';
    var ref = function ref(node) {
      return _this.ref = node;
    };
    return React.createElement(element, {
      ref: ref,
      children: children
    });
  };
  return ClosableWrapper;
}(React.PureComponent);
var _default = ClosableWrapper;
exports.default = _default;